<template>
  <el-main>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12"
        :offset="6">
        <img
          class="mb-3"
          src="@/assets/images/logo.png"
          alt=""
          width="80" />
        <dara-header size="md">{{ $t('welcome-to-dara') }}</dara-header>
        <small>{{ $t('please-enter-your-information') }}</small>
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12"
        :offset="6">
        <el-steps :active="active" finish-status="success" align-center>
          <el-step :title="$t('step-1')" :description="$t('user-registration')"></el-step>
          <el-step :title="$t('step-2')" :description="$t('company-registration')"></el-step>
        </el-steps>
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12"
        :offset="6">
        <dara-user-registration-form v-if="active == 0" class="mt-5" :language="language" @next="next()" />
        <dara-company-registration-form v-if="active == 1" class="mt-5" :language="language" @previous="previous()" @onRegister="onRegister()" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12"
        :offset="6">
        <div v-if="error">
          <div class="alert alert-danger" role="alert">
            {{ error }}
          </div>
        </div>
        <div class="d-grid text-center">
          <p>
            {{ $t('already-have-an-account') }}
            <router-link class="color--primary" to="/login">{{ $t('login') }}</router-link>
          </p>
        </div>
        <div class="d-grid text-center color--primary">
          <p v-if="language == 'en'" class="cursor--pointer" @click="changeLanguage('pt-br')">Português</p>
          <p v-else class="cursor--pointer" @click="changeLanguage('en')">English</p>
        </div>
      </dara-col>
    </dara-row>
  </el-main>
</template>

<script>
import { register } from '@/modules/auth/auth.service';
import { goToBasePage } from '@/router/route.service';
import { translate, setLanguage, getCookieLanguage } from '@/services/translate.service';

import DaraUserRegistrationForm from '@/modules/auth/components/UserRegistrationForm.vue';
import DaraCompanyRegistrationForm from '@/modules/auth/components/CompanyRegistrationForm.vue';

export default {
  name: 'DaraRegisterPage',
  components: {
    DaraUserRegistrationForm,
    DaraCompanyRegistrationForm,
  },
  provide() {
    const infoRegisterVm = {};
    Object.defineProperty(infoRegisterVm, 'info', {
      get: () => this.info,
    });
    return { infoRegisterVm };
  },
  data() {
    return {
      active: 0,
      info: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        confirm_password: null,
        language: null,
        company: {
          name: null,
          vat: null,
          country: null,
          state: null,
          city: null,
          zip: null,
          first_address: null,
          second_address: null,
        },
      },
      error: null,
      language: 'en',
    };
  },
  beforeMount() {
    this.changeLanguage(getCookieLanguage());
  },
  methods: {
    next() {
      this.active++;
    },
    previous() {
      this.active--;
    },
    onRegister() {
      this.info.language = this.language;
      register(this.info)
        .then(goToBasePage)
        .catch(err => {
          switch (err.response.data.errors.field) {
          case 'email':
            this.error = translate('email-already-exist');
            break;
          case 'company.company_name':
            this.error = translate('company-name-already-exist');
            break;
          case 'company.vat':
            this.error = translate('vat-cnpj-already-exist');
            break;
          default:
            this.error = err;
            break;
          }
        });
    },
    changeLanguage(language) {
      this.language = language;
      setLanguage(language);
    },
  },
};
</script>
<style scoped>
span {
  width: 620px;
}
button {
  width:150px;
}
</style>
